<template>
  <div class="course-share-wrap">
    <!-- <button
      @click="shareInApp"
      slot="reference"
      class="share-icon"
      v-preventReClick
      v-if="isHXApp"
    >
      <img src="../../../assets/images/course-share/share-icon.png" alt="" />
    </button> -->
    <!-- v-else -->
    <el-popover
      placement="right-start"
      trigger="click"
      popper-class="course-share-popover"
      @after-leave="selectShare = {}"
    >
      <!-- v-if="!isWeChat && !isQQ" -->
      <button slot="reference" class="share-icon" v-preventReClick>
        <img src="../../../assets/images/course-share/share-icon.png" alt="" />
      </button>
      <div class="share-box">
        <div class="share-list" v-if="!selectShare.type">
          <div class="share-item copy-item" @click="handleCopyPageUrl">
            <img src="../../../assets/images/course-share/link.png" alt="" />
            <span>复制链接</span>
          </div>
          <div class="divider"></div>
          <div class="share-item" @click="handleShare('wechat')">
            <img src="../../../assets/images/course-share/wx.png" alt="" />
            <span>微信</span>
          </div>
          <div class="share-item" @click="handleShare('circle')">
            <img
              src="../../../assets/images/course-share/wx-circle.png"
              alt=""
            />
            <span>朋友圈</span>
          </div>
          <div class="share-item" @click="handleShare('QQ')">
            <img src="../../../assets/images/course-share/QQ.png" alt="" />
            <span>QQ</span>
          </div>
          <div class="share-item" @click="handleShare('space')">
            <img
              src="../../../assets/images/course-share/QQ-space.png"
              alt=""
            />
            <span>QQ空间</span>
          </div>
          <div class="share-item" @click="handleShare('weibo')">
            <img src="../../../assets/images/course-share/weibo.png" alt="" />
            <span>微博</span>
          </div>
        </div>
        <div class="share-content" v-else>
          <div class="title">
            <img
              src="../../../assets/images/course-share/back.png"
              alt=""
              @click="handleShareBack"
            />
            <span>分享到{{ selectShare.title }}</span>
          </div>
          <div class="qrcode-box">
            <create-qr-code
              ref="qrCode"
              :url="courseDetailUrl"
              :logo-url="logoUrl"
              :canvas-width="140"
              :canvas-height="140"
              @create-qr-code="getQrCode"
            />
          </div>
          <div class="tips">{{ selectShare.content }}</div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import CreateQrCode from "@saas/components/src/components/CreateQrCode";
import shareSdk from "@saas/components/src/utils/share";
import {
  copyPageUrl,
  clipboard,
  isHXApp,
  isWeChat,
  isQQ,
  isH5,
} from "@saas/components/src/utils/utils";
// import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
export default {
  props: {
    productInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      // isH5: isH5(),
      // isHXApp: isHXApp(),
      // isWeChat: isWeChat(),
      // isQQ: isQQ(),
      selectShare: {
        type: "",
      },
      logoUrl: process.env.VUE_APP_CDN_URL + "/cdn/static/images/favicon.ico",
    };
  },
  methods: {
    getQrCode(url) {},
    // shareInApp() {
    //   let { course_name, id, cover_url, goods = {} } = this.productInfo;
    //   jsToFlutter("shareAction", {
    //     courseName: course_name || "",
    //     courseUrl: `${process.env.VUE_APP_SAAS_WEB_URL}/product-detail/${id}`,
    //     coverUrl: cover_url,
    //     courseId: id,
    //     postUrl: this.posterUrl || "",
    //     price: goods.price,
    //   });
    // },
    handleCopyPageUrl() {
      if (window.isElectron) {
        clipboard(this.courseDetailUrl, () => {
          this.$showToast("已复制课程链接，粘贴即可分享");
          this.isShowShare = false;
        });
      } else {
        copyPageUrl("", this.courseDetailUrl);
        this.isShowShare = false;
      }
    },
    handleShare(type) {
      if (type === "wechat") {
        this.selectShare = {
          type: "wechat",
          title: "微信",
          content: "扫描二维码，将课程分享给微信好友吧。",
        };
      } else if (type === "QQ") {
        this.selectShare = {
          type: "QQ",
          title: "QQ",
          content: "扫描二维码，将课程分享给QQ好友吧。",
        };
      } else if (type === "space") {
        this.selectShare = {
          type: "space",
          title: "QQ空间",
          content: "扫描二维码，将课程分享到QQ空间吧。",
        };
      } else if (type === "circle") {
        this.selectShare = {
          type: "circle",
          title: "朋友圈",
          content: "扫描二维码，将课程分享到朋友圈吧。",
        };
      } else if (type === "weibo") {
        shareSdk("weibo", {
          url: this.courseDetailUrl, // 分享地址
          title: this.productInfo.course_name, // 分享标题
          pic: this.productInfo.cover_url,
        });
      }
    },
    handleShareBack() {
      this.selectShare = {
        type: "",
      };
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    courseDetailUrl() {
      return `${process.env.VUE_APP_SAAS_WEB_URL}/product-detail/${this.productInfo.id}`;
    },
  },
  components: {
    CreateQrCode,
  },
};
</script>

<style lang="scss" scoped>
.share-icon {
  z-index: 1999;
  position: relative;
  -webkit-app-region: none;
  cursor: pointer;
  // top: 1px;
  width: 18px;
  height: 25px;
  margin-left: 10px;
  img {
    height: 16px;
    width: 16px;
  }
}
.share-box {
  .share-list {
    -webkit-app-region: none;
    padding: 9px 8px 5px 8px;
    .share-item {
      width: 174px;
      height: 38px;
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 6px;
      cursor: pointer;
      &:hover {
        background: #f6f8fc;
      }
      img {
        width: 20px;
        height: 20px;
        margin-left: 6px;
        margin-right: 7px;
      }
      span {
        font-size: 14px;
        color: #0d1400;
        line-height: 20px;
      }
      &.copy {
      }
    }
    .divider {
      width: 173px;
      height: 1px;
      background: #f2f3f5;
      margin: 7px 0 3px 0;
    }
  }
  .share-content {
    -webkit-app-region: none;
    width: 190px;
    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 14px;
      margin-left: 19px;
      img {
        cursor: pointer;
        width: 6px;
        height: 9px;
        margin-right: 6px;
      }
      span {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
      }
    }
    .qrcode-box {
      margin-top: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .tips {
      padding: 0 13px 21px 16px;
      margin-top: 22px;
      font-weight: 400;
      font-size: 16px;
      color: #0d1400;
      line-height: 22px;
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.course-share-popover {
  padding: 0 !important;
  border-radius: 12px;
}
</style>
